import React, { useState } from "react";
import { DataGrid } from "@material-ui/data-grid";
import {
  Button,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import {
  contratacionesPrestadoresDelete, contratacionesPrestadorSave,
} from "../../../actions/contrataciones/contratacionesCartilla";
import { CATEGORIAS_VALORIZACIONES_ARRAY, SUBTIPO_EFECTORES, TIPO_MATRICULA } from "../../../utils/constants";
import DeleteForever from '@material-ui/icons/DeleteForever';
import EditIcon from "@material-ui/icons/Edit";
import { PrestadoresForm } from "./PrestadoresForm";
import moment from 'moment'
import CartillaPrestadoresButton from "./CartillaPrestadoresButton";

const RenderEditButton = (cellValue) => {
  const dispatch = useDispatch();

  const [openEdit, setOpenEdit] = useState(false)
  return (
    <strong>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={() => {
          setOpenEdit(true)
        }}
      >
        <EditIcon />
      </Button>

      {
        openEdit && (
          <Dialog
            open={openEdit}
            onClose={(e) => setOpenEdit(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Guardar Prestador"}
            </DialogTitle>
            <DialogContent>
              <PrestadoresForm formData={cellValue.row} handleSubmit={(data) => {
                dispatch(contratacionesPrestadorSave(data))
                setOpenEdit(false)
                }} 
                handleCloseModal={() => setOpenEdit(false)}
                />
            </DialogContent>
          </Dialog>
        )
      }
    </strong>
  );
};

const RenderDeleteButton = (cellValue) => {
  const dispatch = useDispatch();
  const [openDelete, setOpenDelete] = useState(false)
  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={(e) => {
          setOpenDelete(true)
        }}
      >
        <DeleteForever />
      </Button>
      {
        openDelete && (
          <Dialog
            open={openDelete}
            onClose={(e) => setOpenDelete(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Eliminar Prestador"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                ¿Desea eliminar este Prestador de forma permanente?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  dispatch(
                    contratacionesPrestadoresDelete(
                      cellValue.row.id
                    )
                  );
                  setOpenDelete(false);
                }}
                color="primary"
              >
                Aceptar
              </Button>
              <Button
                onClick={(e) => {
                  setOpenDelete(false);
                }}
                color="primary"
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>
        )
      }
    </>
  );
};

let columns = (dataContrato, disabled) => [
  { field: "nombreApellido", headerName: "Nombre y Apellido", width: 500 },
  { field: "cuit", headerName: "CUIT", width: 140 },
  {
    field: "matriculaProvincial",
    headerName: "Matricula Provincial",
    width: 200,
    hide: !(
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.FARMACIA
    )
  },
  { 
    field: "matriculaNacional", headerName: "Matricula Nacional", width: 200,
    hide: !(
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.FARMACIA
    )
  },
  { 
    field: "rnp", headerName: "RNP", width: 200,
    hide: !(
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.FARMACIA
    )
  },
  { 
    field: "categoria", headerName: "Categoria", width: 200, 
    hide: (
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.FARMACIA
    ),
  },
  {
    field: "fechaBaja",
    headerName: "Fecha de Baja",
    width: 150,
    renderCell: (cellValue)=>cellValue.row.fechaBaja !== null && moment(cellValue.row.fechaBaja).format('DD/MM/YYYY'),
    disableClickEventBubbling: true,
    hide: (
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.FARMACIA
    )
  },
  {
    field: "colEditButton",
    headerName: "Editar",
    width: 158,
    renderCell: RenderEditButton,
    disableClickEventBubbling: true,
    hide: disabled,
  },
  {
    field: "colDeleteButton",
    headerName: "Eliminar",
    width: 173,
    renderCell: RenderDeleteButton,
    disableClickEventBubbling: true,
    hide: (disabled || (
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES && 
      dataContrato.idSubTipoEfector !== SUBTIPO_EFECTORES.FARMACIA
    )),
  },
  {
    field: "colCartilla",
    headerName: "Cartilla",
    width: 173,
    renderCell: (cellValue) => <CartillaPrestadoresButton idPrestador={cellValue.row.idPrestador} cartillaPrestadores={cellValue.row.cartillaPrestadores} disabled={disabled} />,
    disableClickEventBubbling: true,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    height: "65vh",
    width: "100%",
  },
}));

export const PrestadoresTable = (props) => {
  const classes = useStyles();

  const { prestadores } = useSelector((state) => state.contratacionesCartilla);
  const { dataContrato } = useSelector((state) => state.contrataciones);

  const prestadoresFormateados = prestadores.map(
    (prestador, index) => {
      const matriculaNacional =
        prestador.prestadoresMatriculas.find(
          (matricula) =>
            matricula.idTipoMatricula === TIPO_MATRICULA.MATRICULA_NACIONAL
        );
      const matriculaProvincial =
        prestador.prestadoresMatriculas.find(
          (matricula) =>
            matricula.idTipoMatricula === TIPO_MATRICULA.MATRICULA_PROVINCIAL
        );

      return {
        ...prestador,
        id: prestador.idPrestador,
        matriculaNacional: matriculaNacional?.numero,
        matriculaProvincial: matriculaProvincial?.numero,
        categoria: prestador.idCategoriaValorizaciones !== null ? CATEGORIAS_VALORIZACIONES_ARRAY.find(x=>x.id === prestador.idCategoriaValorizaciones)?.descripcion : "",
      };
    }
  );

  return (
    <React.Fragment>
      <div className={classes.root}>
        <DataGrid
          rows={prestadoresFormateados}
          rowHeight={40}
          columns={columns(dataContrato, props.disabled)}
          setRowProps={{
            responsive: "scroll",
          }}
          columnBuffer={12}
          pageSize={15}
          showToolbar
          rowsPerPageOptions={[15, 20]}
          density="comfortable"
          localeText={{
            noRowsLabel: "No hay Prestadores",
            toolbarDensity: "Tamaño",
            toolbarDensityLabel: "Tamaño",
            toolbarDensityCompact: "Chico",
            toolbarDensityStandard: "Mediano",
            toolbarDensityComfortable: "Grande",
            toolbarColumns: "Columnas",
            toolbarColumnsLabel: "Selección de Columnas",
            toolbarFilters: "Filtros",
            toolbarFiltersLabel: "Mostrar Filtros",
            toolbarFiltersTooltipHide: "Ocultar Filtros",
            toolbarFiltersTooltipShow: "Mostrar Filtros",
            toolbarFiltersTooltipActive: (count) => `${count} Filtros Activos`,
            // Columns panel text
            columnsPanelTextFieldLabel: "Buscar columna",
            columnsPanelTextFieldPlaceholder: "Columnas",
            columnsPanelDragIconLabel: "Reordenar Columnas",
            columnsPanelShowAllButton: "Mostrar Todas",
            columnsPanelHideAllButton: "Ocultar Todas",
            // Filter panel text
            filterPanelAddFilter: "Agregar Filtros",
            filterPanelDeleteIconLabel: "Eliminar",
            filterPanelOperators: "Operador",
            filterPanelOperatorAnd: "Y",
            filterPanelOperatorOr: "O",
            filterPanelColumns: "Columnas",
            filterPanelInputLabel: "Valor",
            filterPanelInputPlaceholder: "Filtrar por valor",
            // Filter operators text
            filterOperatorContains: "Contiene",
            filterOperatorEquals: "Igual",
            filterOperatorStartsWith: "Empieza con",
            filterOperatorEndsWith: "Termina con",
            filterOperatorIs: "es",
            filterOperatorNot: "no es",
            filterOperatorOnOrAfter: "después",
            filterOperatorBefore: "antes",
            filterOperatorOnOrBefore: "antes",
            // Column menu text
            columnMenuLabel: "Menú",
            columnMenuShowColumns: "Mostrar",
            columnMenuFilter: "Filtros",
            columnMenuHideColumn: "Ocultar",
            columnMenuUnsort: "Deshacer",
            columnMenuSortAsc: "Ordenar Asc",
            columnMenuSortDesc: "Ordenar Desc",
            // Column header text
            columnHeaderFiltersTooltipActive: (count) =>
              `${count} filtros activos`,
            columnHeaderFiltersLabel: "Filtros",
            columnHeaderSortIconLabel: "Ordenar",
            // Rows selected footer text
            footerRowSelected: (count) =>
              count !== 1
                ? `${count.toLocaleString()} fila/s seleccionada/s`
                : `${count.toLocaleString()} fila/s seleccionada/s`,
            // Total rows footer text
            footerTotalRows: "Total Registros:",
            // Pagination footer text
            footerPaginationRowsPerPage: "Registros por página:",
          }}
        />
      </div>
    </React.Fragment>
  );
};
